<template>
  <div v-if="userData" class="profile-content col-12 row mx-0 justify-content-between px-0">
    <div class="col-12 col-lg-10 mx-auto">
      <div v-if="userData" class="user-info bg-transparent text-white">
        <b-list-group>
          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>Логин</small>
              </div>
              <div class="col-12 text-left">
                <span>{{ userData.login }}</span>
                <a class="text-muted profile-logout float-right" href="#" @click.prevent="logout">
                  <small>
                    Выход
                    <i v-if="!loggingOut" class="fa fa-arrow-right ml-1"></i>
                    <i v-else class="fa fa-spinner fa-spin small-spin text-white"></i>
                  </small>

                </a>
              </div>
            </div>
          </b-list-group-item>

          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>Ваше имя</small>
              </div>
              <div class="col-12 text-left">
                <span>{{ userData.name }}</span>
                <form class="w-100" v-if="!userData.name">
                  <Alert :message="updateNameResponse"></Alert>
                  <fieldset class="form-group row m-0">
                    <div class="col-6 col-md-5 col-lg-8 px-0">
                      <input type="text" placeholder="Ваше имя *" required aria-required="true"
                            class="form-control main-input" v-model="usersName">
                    </div>
                    <div class="col-6 col-lg-4 px-0 text-lg-center">
                      <b-button class="btn dark-btn float-right btn-secondary" @click.stop.prevent="updateUsersName">
                        Подтвердить
                      </b-button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </b-list-group-item>

          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>Телефон</small>
              </div>
              <div class="col-12 text-left">
                <span class="user-phone-text">
                  <the-mask
                    type="text"
                    class="user-phone text-white text-left border-0 pt-2"
                    :value="userData.phone || 'не имеется'"
                    :mask="userData.phone? '+#(###)-###-##-##': 'не имеется'" />
                </span>
                <b-button name="confirmPhone"
                  v-if="!userData.phone_confirmed"
                  class="dark-btn float-right"
                  @click.prevent="confirmPhone">
                  Подтвердить
                </b-button>
                <small v-else class="float-right text-success user-detail-state">
                  подтверждено
                </small>
              </div>
            </div>
          </b-list-group-item>

          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>Пароль</small>
              </div>
              <div class="col-12 text-left">
                <span class="pt-2 d-inline-block">**********</span>
                <b-button name="changePassword"
                  v-if="userData.phone_confirmed||userData.email_confirmed"
                  class="dark-btn float-right"
                  @click.prevent="changePassword">
                  Изменить
                </b-button>
                <small v-else class="col-9 px-0 d-inline-block float-right text-muted">
                  Пароль можно изменить только после подтверждения номера телефона или адреса электронной почты
                </small>
              </div>
            </div>
          </b-list-group-item>

          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>E-mail</small>
              </div>
              <div class="col-12 text-left">
                <span class="d-inline-block pt-2 user-email-text ">{{ userData.email }}</span>
                <b-button name="confirmEmail"
                  v-if="!userData.email_confirmed"
                  class="dark-btn float-right"
                  @click.prevent="confirmEmail">
                  Подтвердить
                </b-button>
                <small v-else class="float-right text-success user-detail-state">
                  подтверждено
                </small>
              </div>
            </div>
          </b-list-group-item>
          <b-list-group-item class="bg-transparent">
            <div class="row">
              <div class="col-12 text-left text-muted">
                <small>Верификация аккаунта</small>
              </div>
              <div class="col-12 text-left row mx-0">
                <div class="col-6 col-lg-9 px-0">
                  <p class="d-inline-block pt-2 user-verified-text mb-0" v-if="accountIdentifyStatus">
                    <span v-html="accountIdentifyStatus"></span>
                  <br>
                  <small v-if="accountIdentifyStatusDesc" v-html="accountIdentifyStatusDesc"></small>
                </p>
                </div>

                <div class="col-6 col-lg-3 px-0">
                  <b-button name="identifyPerson"
                            v-if="showIdentificationButton"
                            class="dark-btn float-right"
                            @click.prevent="confirmPassport">
                    Пройти верификацию
                  </b-button>
                  <small v-else-if="!showIdentificationButton && userData.verified === 1" class="float-right text-success user-detail-state">
                    подтверждено
                  </small>
                  <small v-else class="float-right text-warning user-detail-state">
                    в процессе
                  </small>
                </div>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>

        <div v-if="wheelStats" class="wheel-access py-3 px-1">
          <h6 class=" text-center font-weight-bold">
            Колесо VipMagnit
          </h6>
          <div class="w-100 text-center">
            <div class="progress">
              <div
                class="progress-bar bg-wheel-progress"
                role="progressbar"
                :style="{ width: wheelStats.progressPercent + '%' }"
                aria-valuemin="0"
                aria-valuemax="100">
              </div>
              <span class="wheel-stat-value">{{ wheelStats.progressPercent + '%' }}</span>
            </div>
          </div>

          <div class="wheel-access-desc my-2 text-left">
            <span class="red-color text-center d-block font-weight-bold">
              У Вас - {{ wheelStats.lastMonthDeposit }} / {{ wheelStats.profitBorder }}
            </span>

            <small class="text-muted d-block mt-2">
              Колесо Фортуны активируется при пополнении от {{ wheelStats.profitBorder }} руб. в течение 30 дней.
            </small>

            <small class="text-muted d-block mt-2">
              К примеру: для доступа к Колесу Фортуны сегодня, сумма Ваших пополнений за {{setDates.monthAgo}}
              до {{setDates.now}} должна быть больше {{ wheelStats.profitBorder }} руб.
            </small>
          </div>
        </div>
        <div v-else class="col-12 col-lg-5 d-none d-lg-block px-lg-0
                    row justify-content-center w-100  mx-0 h-100 py-4 text-center mx-auto">
          <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
        </div>
      </div>
    </div>
    <ConfirmPhoneViaCall :user-data="userData" v-if="mainSettings && mainSettings.phoneActionsMethod ==='call'"></ConfirmPhoneViaCall>
    <ConfirmPhone :user-data="userData" v-else></ConfirmPhone>
    <ConfirmEmail :user-data="userData"></ConfirmEmail>
    <ChangePassword :user-data="userData"></ChangePassword>
    <ConfirmPassport :user-data="userData" v-if="userData.verified !== 1" @changed="updateState()"></ConfirmPassport>
  </div>
  <div v-else class="col-12 col-lg-5 d-none d-lg-block px-lg-0
                    row justify-content-center w-100  mx-0 h-100 py-4 text-center mx-auto">
    <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
  </div>
</template>

<script>
import ConfirmPhone from '@/components/user/actions/ConfirmPhone'
import ConfirmPhoneViaCall from '@/components/user/actions/ConfirmPhoneViaCall'
import ConfirmEmail from '@/components/user/actions/ConfirmEmail'
import ConfirmPassport from '@/components/user/actions/ConfirmPassport'
import ChangePassword from '@/components/user/actions/change-password/ChangePassword'
import Alert from '@/components/Alert'

export default {
  name: 'Profile',
  data () {
    return {
      userIcon: '',
      loggingOut: false,
      identityData: null,
      accountIdentifyStatus: null,
      accountIdentifyStatusDesc: null,
      showIdentificationButton: false,
      updateNameResponse: null,
      usersName: ''
    }
  },
  components: {
    ConfirmPhone,
    ConfirmEmail,
    ChangePassword,
    ConfirmPassport,
    ConfirmPhoneViaCall,
    Alert
  },
  computed: {
    setDates () {
      let date = new Date()
      let monthAgo = new Date(date)
      monthAgo.setDate(monthAgo.getDate() - 30)
      date = new Date(date).toLocaleString('en-US',{ hour12: false })
      monthAgo = new Date(monthAgo).toLocaleString('en-US', { hour12: false })

      return {now: date, monthAgo: monthAgo}
    },
    userData () {
      return this.$store.getters.userData
    },
    wheelStats () {
      let stat = this.$store.getters.getWheelStats
      if (!stat) {
        this.$store.dispatch('fetchWheelStatistic')
      }
      return this.$store.getters.getWheelStats
    },
    userIdentityData() {
      return this.$store.getters.identityData
    },
    mainSettings () {
      return this.$store.getters.getMainSettings
    },
    userDataFetched () {
      return this.$store.getters.userDataFetched
    }
  },
  updated() {
    this.identityData = this.$store.getters.identityData
  },
  async created() {
    await this.$store.dispatch('fetchUserIdentityData')
  },
  mounted () {
    this.identityData = this.$store.getters.identityData
    setTimeout(() => {
      this.updateState()
    }, 1000)
  },
  methods: {
    logout () {
      this.loggingOut = true
      this.axios.get(
        this.$_config.baseUrl + '/Api/logout'
      ).then(() => {
        this.$store.dispatch('removeUserData')
        this.$router.push({ name: 'home' })
      }).catch(err => {
        console.log(err)
      })
    },
    changePassword () {
      this.$root.$emit('bv::show::modal', 'changePasswordModal')
    },
    confirmPhone () {
      this.$root.$emit('bv::show::modal', 'confirmPhoneModal')
    },
    confirmEmail () {
      this.$root.$emit('bv::show::modal', 'confirmEmailModal')
    },
    confirmPassport () {
      this.$root.$emit('bv::show::modal', 'confirmPassportModal')
    },
    setAccountIdentifyStatus () {
      if (!this.userData) {
        return
      }
      let accountVerified = this.userData.verified
      let identifyConfirmedStatus = false

      if (this.identityData) {
        identifyConfirmedStatus = this.identityData.approved
      }
      this.showIdentificationButton = false
      this.accountIdentifyStatus = null
      this.accountIdentifyStatusDesc = null

      switch (accountVerified) {
        case 0:
          this.showIdentificationButton = true
          this.accountIdentifyStatus = '<span class="text-danger">Аккаунт не верифицирован</span>'
          if (identifyConfirmedStatus && identifyConfirmedStatus === 2) {
            const reason = this.identityData.reject_reason
            this.accountIdentifyStatusDesc = `<span class="text-danger">Верификация отказано - ${reason}</span>`
          }
          if (identifyConfirmedStatus !== false && identifyConfirmedStatus === 0) {
            this.showIdentificationButton = false
            this.accountIdentifyStatus = '<span class="text-warning">Данные в оброботке</span>'
          }
          break;
        case -1:
          this.showIdentificationButton = true
          this.accountIdentifyStatus = '<strong class="text-danger">Необхадимо пройти верификацию !</strong>'

          if (identifyConfirmedStatus !== false && identifyConfirmedStatus === 0) {
            this.showIdentificationButton = false
            this.accountIdentifyStatus = '<span class="text-warning">Данные в оброботке</span>'
          }
          if (identifyConfirmedStatus && identifyConfirmedStatus === 2) {
            const reason = this.identityData.reject_reason
            this.showIdentificationButton = true
            this.accountIdentifyStatus = '<span class="text-warning">Получено запрос на верификацию</span>'
            this.accountIdentifyStatusDesc = `<span class="text-danger">Верификация отказано - ${reason}</span>`
          }
          break
        case 1:
          this.accountIdentifyStatus = '<span class="text-success">Аккаунт верифицирован</span>'
          break
      }
    },
    updateState () {
      this.identityData = this.$store.getters.identityData
      this.setAccountIdentifyStatus()
    },
    updateUsersName() {
      this.updateNameResponse = {status: 'loading'}
      let queryString = `name=${this.usersName}`
      this.axios.post(
              this.$_config.baseUrl + '/Api/updateUserName/', queryString,
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
      ).then(({data}) => {
        this.updateNameResponse = data

        if (data.status !== "error") {
          this.$store.dispatch('fetchUserData')
          setTimeout(() => {
            this.updateNameResponse = null
          }, 5000)
        }
      }).catch(() => {
        this.updateNameResponse = {
          status: 'error', msg: 'Ошибка при отправке запроса, повторите позже'
        }
      })
    }

  },
  watch: {
    userDataFetched  (newState) {
        if (newState) {
          if (!this.userData.login) {
            window.location.reload()
          }
          this.updateState()
        }
    },
    identityData : {
      handler : function () {
          this.updateState()
      },
      deep: true

    },
    userData: {
      handler: function (data) {
        if (data) {
          this.setAccountIdentifyStatus()
        }
      },
      deep: true
    }
  }
}
</script>

<style>
  .profile-logout:hover *{
    color: #860019;
  }
  .user-phone{
      border: unset !important;
      background-color: transparent !important;
  }
  .profile-description{
    background-color: #3d3d3d;
  }
  .user-info .list-group-item{
    border: none ;
    padding: 5px 0 10px !important;
    border-bottom: 1px solid #6a7075;
  }
  .wheel-access .progress{
    height: 25px;
    border-radius: 3px;
    background-color: #00000017;
    box-shadow: 0 0 4px 1px #fff inset !important;
    position: relative;
    line-height: 1.5;
  }
  .bg-wheel-progress{
    border-radius: 4px;
    background: #b50220;
    background: -moz-linear-gradient(left,  #b50220 0%, #c00912 28%, #c30b0f 58%, #ea2f05 100%);
    background: -webkit-linear-gradient(left,  #b50220 0%,#c00912 28%,#c30b0f 58%,#ea2f05 100%);
    background: linear-gradient(to right,  #b50220 0%,#c00912 28%,#c30b0f 58%,#ea2f05 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b50220', endColorstr='#ea2f05',GradientType=1 );
  }
  .wheel-stat-value{
    position: absolute;
    width: 100%;
    text-align: center;
    height: 100%;
    font-size: 15px;
  }
  .user-detail-state{
    text-decoration:underline;
    font-style: italic
  }
  @media screen and (max-width: 768px) {
    .profile-user-icon {
      height: 80px;
    }
    .user-email-text,.user-phone-text{
      max-width: 55%;
      overflow: hidden;
      display: inline-block;
    }
  }
</style>
